import { useState } from 'react';

const NEXT_ID = {};
/**
 * Este hook cria um ID único sequencial. O ID gerado não é aleatório e nem dinâmico, o que facilita
 * para testes de snapshot.
 *
 * @param defaultId ID que pode ser recebido pelo componente por props e será considerado primeiro.
 * @param componentName Nome do componente para criar o ID único e sequencial, caso não receba um ID
 * por props.
 * @returns O mesmo ID recebido por props ou outro que foi gerado.
 *
 * @example
 * ```tsx
 * import { useId } from '@ids/react';
 *
 * function App({ id: defaultId }) {
 *   const id = useId(defaultId, 'ids-option'); // 'ids-option-1'
 *
 *   return <div id={id}></div>;
 * }
 * ```
 */
const useId = (defaultId = '', componentName) => {
  if (!NEXT_ID[componentName]) {
    NEXT_ID[componentName] = 0;
  }
  // eslint-disable-next-line react/hook-use-state
  const [id] = useState(defaultId || `${componentName}-${NEXT_ID[componentName]++}`);
  return id;
};

export { useId as u };
//# sourceMappingURL=use-id.js.map
